import { createSlice } from '@reduxjs/toolkit';

import UnauthService from 'services/Unauth.service';

const initialState = {};

const noticeSlice = createSlice({
  name: 'notice',
  initialState,
  reducers: {
    cleanAll (state) {
      Object.assign(state, initialState);
    },
    set (state, action) {
      Object.assign(state, action.payload);
    },
  },
});

export const fetchNotice = () => {
  return async (dispatch) => {
    const response = await UnauthService.getNotice();
    dispatch(noticeActions.set(response.data));
  };
};

export const noticeActions = noticeSlice.actions;

export default noticeSlice;